/**
 * Iter208.77 — PublicSite router wrapper.
 *
 * Fa un solo fetch di /public/site/:slug e, in base a `site_config.template_id`,
 * monta il componente template corrispondente:
 *   - "casa-vicina"      → CasaVicinaSite
 *   - "atrium-editorial" → AtriumSite (default)
 *   - qualsiasi altro    → AtriumSite (fallback)
 *
 * I template ricevono `initialData` per evitare un secondo fetch.
 */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import AtriumSite from "@/pages/public/AtriumSite";
import CasaVicinaSite from "@/pages/public/CasaVicinaSite";
import VillaRealeSite from "@/pages/public/VillaRealeSite";
import MeridianSite from "@/pages/public/MeridianSite";
import BottegaCaseSite from "@/pages/public/BottegaCaseSite";
import { SiteEditProvider, SiteEditToolbar } from "@/lib/siteEditing";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicSite() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [meId, setMeId] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/site/${slug}`)
      .then((r) => setData(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
    // Iter208.82 — se richiesto edit mode, verifica se sono il proprietario del sito
    if (searchParams.get("edit") === "1") {
      const token = localStorage.getItem("ht_token");
      if (token) {
        axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
          .then((r) => { if (r.data?.id === slug || r.data?._id === slug) setMeId(r.data.id || r.data._id); })
          .catch(() => {});
      }
    }
  }, [slug, searchParams]);

  if (loading) {
    return (
      <div style={{padding:"120px 20px",textAlign:"center",fontFamily:"sans-serif",color:"#666"}}>
        Caricamento sito…
      </div>
    );
  }
  if (notFound || !data) {
    return (
      <div style={{padding:"120px 20px",textAlign:"center",fontFamily:"sans-serif",color:"#666"}} data-testid="public-site-not-found">
        Sito non trovato.{" "}
        <button onClick={() => navigate("/")} style={{background:"none",border:"none",color:"#7C3AED",cursor:"pointer",textDecoration:"underline"}}>
          Torna alla homepage
        </button>
      </div>
    );
  }

  const templateId = (data.site_config?.template_id || "").trim();
  const isOwner = !!meId;
  const token = localStorage.getItem("ht_token");
  let TemplateCmp = AtriumSite;
  if (templateId === "casa-vicina") TemplateCmp = CasaVicinaSite;
  else if (templateId === "villa-reale") TemplateCmp = VillaRealeSite;
  else if (templateId === "meridian") TemplateCmp = MeridianSite;
  else if (templateId === "bottega-case") TemplateCmp = BottegaCaseSite;
  return (
    <SiteEditProvider
      enable={isOwner}
      initialEdits={data.site_config?.text_edits || {}}
      initialHidden={data.site_config?.hidden_sections || []}
      token={token}
    >
      <SiteEditToolbar/>
      <TemplateCmp slug={slug} initialData={data}/>
    </SiteEditProvider>
  );
}
